import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useAnalyticsPageView, useEffectOnce, usePathParam, useViewport } from '@chilecompra/react-kit'
import { Skeleton, Table, TableRow, Toast, Typography } from '@chilecompra/react-kit/components'
import { onGetHistoricalContractsThunk } from './HistoricalContracts.actions'
import TablePlaceholder from '../../components/Placeholders/TablePlaceholder'
import { Column, ExternalLink, Row, Strong, TableCell } from './HistoricalContracts.styles'
import { formatDate } from '../../modules/utils/formatters'
import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'

/**
 * The HistoricalContracts's container.
 */
const HistoricalContracts = () => {
  const dispatch = useDispatch()
  const {
    size: { isUpToMedium }
  } = useViewport()
  const dni = usePathParam('rut')
  const { contracts, error, loading } = useSelector(state => state.historicalContracts)
  const { months } = useSelector(state => state.contractualBehavior)

  useEffectOnce(() => {
    if (!loading) {
      return
    }

    dispatch(onGetHistoricalContractsThunk({ dni }))
  })

  useAnalyticsPageView('/ficha/contrato/historico')
  return (
    <Row margin="14px 0 0">
      <Column xs={12} sm={12} md={9} padding={isUpToMedium ? '0 27px 0 0' : '0'}>
        {!error && loading && (
          <>
            <Skeleton width="100%" />
            <Skeleton width="75%" />
          </>
        )}
        {!error && !loading && (
          <Typography variant="body2">
            {`Estos son los contratos del proveedor que han superado ${
              months === 1 ? 'el último mes' : `los ${months} meses`
            } desde la fecha de aceptación de la orden
            de compra. `}
            Estos contratos <Strong>no son considerados en la nota de evaluación por contratos</Strong> del proveedor.
          </Typography>
        )}

        {loading && !error && <TablePlaceholder margin="28px 0 8px" />}

        {!loading && !error && (
          <Table accessibility={{ label: 'Sanciones históricas' }} margin="28px 0 8px">
            <TableRow>
              <TableCell>
                <Typography fontWeight="bold" variant="caption">
                  Id contrato
                </Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight="bold" variant="caption">
                  Nombre contrato
                </Typography>
              </TableCell>
              <TableCell width="110px">
                <Typography fontWeight="bold" variant="caption">
                  Fecha evaluación
                </Typography>
              </TableCell>
              <TableCell width="110px">
                <Typography fontWeight="bold" variant="caption">
                  Nota
                </Typography>
              </TableCell>
              <TableCell width="70px">
                <Typography fontWeight="bold" variant="caption">
                  Acciones
                </Typography>
              </TableCell>
            </TableRow>
            {contracts.map((contract, index) => {
              return (
                <TableRow key={`contract-${index}`}>
                  <TableCell>
                    <Strong display="block">{contract.dni}</Strong>
                  </TableCell>
                  <TableCell>
                    <Strong>{contract.contractName}</Strong>
                  </TableCell>
                  <TableCell width="110px">{formatDate(contract.publicationDate)}</TableCell>
                  <TableCell width="110px">{contract.contractScore}</TableCell>
                  <TableCell width="70px">
                    <ExternalLink
                      href={`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Contratos/GestionContratos/DetalleContrato?idContrato=${contract.contractId}`}
                      target="_blank"
                    >
                      Ver detalle
                    </ExternalLink>
                  </TableCell>
                </TableRow>
              )
            })}

            {contracts.length === 0 && (
              <TableRow>
                <TableCell colSpan="5">
                  <Typography align="center" color="black3" variant="body2">
                    Este proveedor no registra evaluaciones de contratos históricos.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </Table>
        )}

        {!loading && error && (
          <Toast severity="error" title="Lo sentimos, estamos presentando problemas con nuestro servidor.">
            En estos momentos tenemos problemas para disponibilizar la información. Por favor, consulta en unos minutos
            más.
          </Toast>
        )}
      </Column>
    </Row>
  )
}

export default HistoricalContracts
